export default {
  tab: {
    thisWeek: 'THIS WEEk',
    yesterday: 'YESTERDAY',
    toDay: 'TODAY',
    favorite: 'FAVORITE',
  },
  listTitleTable: {
    TICKER: 'MÃ',
    NEWS_TITLE: 'TIÊU ĐỀ',
    NEWS_SOURCE: 'NGUỒN TIN',
    PUBLIC_DATE: 'GIỜ', // hh:mm
    FAVORITE: 'YÊU THÍCH',
  },

  readMore: 'Xem Thêm',
  share: 'Chia Sẻ',
};
